var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "add-item-header" }, [
    _c("div", { staticClass: "add-item-header-top" }, [
      _vm.title
        ? _c("div", { staticClass: "add-item-title-wrapper" }, [
            _c("div", { staticClass: "add-item-title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showCloseModal
        ? _c(
            "button",
            {
              staticClass: "modal-close-button",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleClick.apply(null, arguments)
                },
              },
            },
            [
              _c("span", { staticClass: "screen-reader" }, [
                _vm._v("Close Cart"),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "add-item-header-bottom" }, [
      _vm.description
        ? _c("div", { staticClass: "add-item-menu-description" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.description) + "\n\t\t"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.price ? _c("div", [_vm._v("$" + _vm._s(_vm.price))]) : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-close" }, [
      _c("div", { staticClass: "icon-close-inner" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }